import { useTextEditorModel } from './text-editor.model'
import type { ITextEditor } from './text-editor.types'
import { TextEditorView } from './text-editor.view'

export const TextEditor = (props: ITextEditor) => {
  const { componentref, ...textComponentModel } = useTextEditorModel(props)
  return (
    <div ref={componentref}>
      <TextEditorView {...textComponentModel} toolbarAlign={props.toolbarAlign} isViewMode={props?.isViewMode} />
    </div>
  )
}
